import React, { useContext } from 'react';
import { AccordionContext, useAccordionButton } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

interface ContextAwareToggleProps {
  children: React.ReactNode;
  eventKey: string;
  isShortSideBar: boolean;
  handleToggle: () => void;
  IconComponent: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

export const ContextAwareToggle: React.FC<ContextAwareToggleProps> = ({
  children,
  eventKey,
  isShortSideBar,
  handleToggle,
  IconComponent
}) => {
  const { activeEventKey } = useContext(AccordionContext);
  const location = useLocation();
  const decoratedOnClick = useAccordionButton(eventKey, () => {
    handleToggle();
  });
  const isCurrentEventKey = activeEventKey === eventKey;
  const isActivePath = location.pathname === eventKey;

  const className = `nav-item ${isCurrentEventKey || isActivePath ? 'active' : ''}`;
  const classNameIcon1 = `icon ${isCurrentEventKey || isActivePath ? 'icon--active1' : ''}`;

  return (
    <div
      className={className}
      onClick={decoratedOnClick}
      style={{ cursor: 'pointer' }}
    >
      <a
        className="nav-link d-flex align-items-center gap-2"
        style={{ color: '#0d6efd' }}
      >
        <IconComponent className={classNameIcon1} />
        {!isShortSideBar && children}
      </a>
    </div>
  );
};
